import { Link, Outlet } from '@remix-run/react'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" className="text-blue-600 underline" prefetch="intent">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/articles/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				Articles
			</Link>
			<Outlet />
		</main>
	)
}
